export function isEmpty(v: unknown): boolean {
    if (v === null || v === undefined) return true
    if (typeof v === "string") return v.trim() === ""
    if (Array.isArray(v)) return v.length === 0
    return false
}

export function isIsoDate(v: unknown): v is string {
    if (typeof v !== "string") return false
    return /^\d{4}-\d{2}-\d{2}$/.test(v)
}
